import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('..\\store\\index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('..\\store\\academy\\actions.ts'), 'academy/actions.ts')
  resolveStoreModules(require('..\\store\\academy\\getters.ts'), 'academy/getters.ts')
  resolveStoreModules(require('..\\store\\academy\\mutations.ts'), 'academy/mutations.ts')
  resolveStoreModules(require('..\\store\\academy\\state.ts'), 'academy/state.ts')
  resolveStoreModules(require('..\\store\\activity\\actions.ts'), 'activity/actions.ts')
  resolveStoreModules(require('..\\store\\baseApi\\actions.ts'), 'baseApi/actions.ts')
  resolveStoreModules(require('..\\store\\common\\actions.ts'), 'common/actions.ts')
  resolveStoreModules(require('..\\store\\common\\getters.ts'), 'common/getters.ts')
  resolveStoreModules(require('..\\store\\common\\mutations.ts'), 'common/mutations.ts')
  resolveStoreModules(require('..\\store\\common\\state.ts'), 'common/state.ts')
  resolveStoreModules(require('..\\store\\community\\actions.ts'), 'community/actions.ts')
  resolveStoreModules(require('..\\store\\community\\getters.ts'), 'community/getters.ts')
  resolveStoreModules(require('..\\store\\community\\mutations.ts'), 'community/mutations.ts')
  resolveStoreModules(require('..\\store\\community\\state.ts'), 'community/state.ts')
  resolveStoreModules(require('..\\store\\contextMenu\\mutations.ts'), 'contextMenu/mutations.ts')
  resolveStoreModules(require('..\\store\\contextMenu\\state.ts'), 'contextMenu/state.ts')
  resolveStoreModules(require('..\\store\\cookies\\actions.ts'), 'cookies/actions.ts')
  resolveStoreModules(require('..\\store\\cookies\\getters.ts'), 'cookies/getters.ts')
  resolveStoreModules(require('..\\store\\cookies\\mutations.ts'), 'cookies/mutations.ts')
  resolveStoreModules(require('..\\store\\cookies\\state.ts'), 'cookies/state.ts')
  resolveStoreModules(require('..\\store\\designers\\actions.ts'), 'designers/actions.ts')
  resolveStoreModules(require('..\\store\\designers\\getters.ts'), 'designers/getters.ts')
  resolveStoreModules(require('..\\store\\designers\\mutations.ts'), 'designers/mutations.ts')
  resolveStoreModules(require('..\\store\\designers\\state.ts'), 'designers/state.ts')
  resolveStoreModules(require('..\\store\\diagrams\\actions.ts'), 'diagrams/actions.ts')
  resolveStoreModules(require('..\\store\\diagrams\\getters.ts'), 'diagrams/getters.ts')
  resolveStoreModules(require('..\\store\\diagrams\\mutations.ts'), 'diagrams/mutations.ts')
  resolveStoreModules(require('..\\store\\diagrams\\state.ts'), 'diagrams/state.ts')
  resolveStoreModules(require('..\\store\\dialogs\\actions.ts'), 'dialogs/actions.ts')
  resolveStoreModules(require('..\\store\\dialogs\\mutations.ts'), 'dialogs/mutations.ts')
  resolveStoreModules(require('..\\store\\dialogs\\state.ts'), 'dialogs/state.ts')
  resolveStoreModules(require('..\\store\\docs\\actions.ts'), 'docs/actions.ts')
  resolveStoreModules(require('..\\store\\docs\\getters.ts'), 'docs/getters.ts')
  resolveStoreModules(require('..\\store\\docs\\mutations.ts'), 'docs/mutations.ts')
  resolveStoreModules(require('..\\store\\docs\\state.ts'), 'docs/state.ts')
  resolveStoreModules(require('..\\store\\pricing\\actions.ts'), 'pricing/actions.ts')
  resolveStoreModules(require('..\\store\\pricing\\getters.ts'), 'pricing/getters.ts')
  resolveStoreModules(require('..\\store\\pricing\\mutations.ts'), 'pricing/mutations.ts')
  resolveStoreModules(require('..\\store\\pricing\\state.ts'), 'pricing/state.ts')
  resolveStoreModules(require('..\\store\\search\\actions.ts'), 'search/actions.ts')
  resolveStoreModules(require('..\\store\\search\\getters.ts'), 'search/getters.ts')
  resolveStoreModules(require('..\\store\\search\\mutations.ts'), 'search/mutations.ts')
  resolveStoreModules(require('..\\store\\search\\state.ts'), 'search/state.ts')
  resolveStoreModules(require('..\\store\\user\\actions.ts'), 'user/actions.ts')
  resolveStoreModules(require('..\\store\\user\\mutations.ts'), 'user/mutations.ts')
  resolveStoreModules(require('..\\store\\user\\state.ts'), 'user/state.ts')
  resolveStoreModules(require('..\\store\\wp\\actions.ts'), 'wp/actions.ts')
  resolveStoreModules(require('..\\store\\wp\\getters.ts'), 'wp/getters.ts')
  resolveStoreModules(require('..\\store\\wp\\mutations.ts'), 'wp/mutations.ts')
  resolveStoreModules(require('..\\store\\wp\\state.ts'), 'wp/state.ts')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs|ts)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
